import React from 'react';
import { Bath, Check, DoorOpen, Hammer, HardHat, Home, Layers, Trees, Wrench } from 'lucide-react';
import { services } from '../../data/services';
const iconMap = {
  layers: Layers,
  home: Home,
  wrench: Wrench,
  hardhat: HardHat,
  hammer: Hammer,
  doorOpen: DoorOpen,
  trees: Trees,
  bath: Bath
} as const;
export function Services() {
  return <section id="services" className="bg-sand py-20 md:py-28" data-id="element-221" data-mp="e4og8gv66su5">
      <div className="mx-auto max-w-7xl px-6" data-id="element-222" data-mp="e6963t6jhnlo">
        <div className="max-w-2xl" data-id="element-223" data-mp="95v2qofvv1tz">
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-brand" data-id="element-224" data-mp="94tq4fj7y7a5">
            Our services
          </p>
          <h2 className="mt-4 font-heading text-3xl font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-225" data-mp="5641trwn75bq">
            One team for every part of your home
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-ink-soft" data-id="element-226" data-mp="1zhiuohky9kvp">
            We provide a wide range of services to meet your needs — including,
            but not limited to, the work below.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2 xl:grid-cols-4" data-id="element-227" data-mp="18gwy5gstqpod">
          {services.map(service => {
          const Icon = iconMap[service.icon];
          return <li key={service.id} className="group flex flex-col overflow-hidden rounded-2xl border border-black/[0.07] bg-white transition-shadow hover:shadow-lg" data-id="element-228" data-mp="zfqbepzl0imo">
                {service.image && <div className="h-40 overflow-hidden" data-id="element-229" data-mp="1w4oc0ou0jarr">
                    <img src={service.image} alt="" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.04]" data-id="element-230" data-mp="1w6913yxk61i8" />
                  </div>}
                <div className="flex flex-1 flex-col p-6" data-id="element-231" data-mp="2azuifcx0tblm">
                  <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-brand-tint text-brand" data-id="element-232" data-mp="2fsnmrzokuhx6">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-233" data-mp="2pmt5ywsrblv2" />
                  </span>
                  <h3 className="mt-4 font-heading text-lg font-semibold text-ink" data-id="element-234" data-mp="2kq2ruf0ij0ca">
                    {service.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-235" data-mp="2fs14vizyugvj">
                    {service.blurb}
                  </p>
                  <ul className="mt-5 space-y-2 border-t border-black/[0.06] pt-5" data-id="element-236" data-mp="26przt8ngvfpj">
                    {service.items.map(item => <li key={item} className="flex gap-2.5 text-sm text-ink-soft" data-id="element-237" data-mp="21wytwhg9i1bv">
                        <Check className="mt-0.5 h-4 w-4 flex-none text-brand" aria-hidden="true" data-id="element-238" data-mp="1x0i31fhoh8v3" />
                        <span data-id="element-239" data-mp="1n1skdkhyjkds">{item}</span>
                      </li>)}
                  </ul>
                </div>
              </li>;
        })}
        </ul>

        <div className="mt-10 flex flex-col items-start justify-between gap-5 rounded-2xl border border-brand/20 bg-brand-tint px-7 py-6 sm:flex-row sm:items-center" data-id="element-240" data-mp="3unauto8typ1q">
          <p className="max-w-2xl text-[15px] leading-relaxed text-ink" data-id="element-241" data-mp="2lbazg2dguob">
            Have a project in mind that isn&apos;t listed here? Reach out — we&apos;re
            happy to discuss how we can help bring your vision to life.
          </p>
          <a href="#quote" className="flex-none rounded-full bg-brand px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-brand-dark" data-id="element-242" data-mp="3aztd715mtg00">
            Tell us about it
          </a>
        </div>
      </div>
    </section>;
}